﻿import { basicSetup } from 'codemirror';
import { EditorState, Compartment } from '@codemirror/state';
import { EditorView } from '@codemirror/view';
import { linter, lintGutter } from '@codemirror/lint';
import { json, jsonParseLinter } from '@codemirror/lang-json';

const jsonminify = require('jsonminify');

const language = new Compartment();
const linterExtension = linter(jsonParseLinter());

const initialState = EditorState.create({
    extensions: [
        lintGutter(),
        basicSetup,
        language.of(json()),
        linterExtension
    ]
});

const view = new EditorView({
    parent: document.getElementById('editor'),
    state: initialState
});

window.view = view;
window.jsonminify = jsonminify;